import script from "./ProjectTasksList.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectTasksList.vue?vue&type=script&setup=true&lang=js"

import "./ProjectTasksList.vue?vue&type=style&index=0&id=3a43075c&lang=scss&scoped=true"

import exportComponent from "/workdir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a43075c"]])

export default __exports__